import { commercetoolsConfig } from '~/commercetools.config';

function mapChildren(parents, categories, result) {
  return parents.map((p) => {
    const currentCategoryId = result?.data?.currentCategory?.id;
    return {
      id: p.id,
      label: p.name,
      slug: p.slug,
      isCurrent: p.id === currentCategoryId,
      count: p.count,
      items: mapChildren(
        categories.filter((c) => c.parent && c.parent.id === p.id),
        categories,
        result,
      ),
    };
  });
}

export function getFacetCategoryTree(searchData) {
  if (!searchData?.data) {
    return {};
  }
  const { categories, rootCategory, currentCategory } = searchData.data;
  const categoriesData = categories.map((f) => ({
    ...f,
    name: f.name,
    slug: f.slug,
  }));
  const parents = categoriesData.filter(
    (f) => (rootCategory && f.ancestors.length === 1 && f.ancestors[0].id === rootCategory.id) || !f.parent,
  );
  return {
    label: rootCategory?.name,
    slug: rootCategory?.slug,
    isCurrent: rootCategory?.id === currentCategory?.id,
    items: mapChildren(parents, categoriesData, searchData),
  };
}

export function getFacetProducts(searchData, filters = { master: true }) {
  if (!searchData?.data) {
    return [];
  }
  if (filters?.master) {
    return searchData.data.results.map((p) => ({
      ...p.masterVariant,
      _id: p.id,
      _name: p.name,
      _slug: p.slug,
      _rating: p.reviewRatingStatistics,
    }));
  }
  return searchData.data.results
    .map((result) => ({
      ...result,
      mapFields: {
        _id: result.id,
        _name: result.name,
        _slug: result.slug,
        _rating: result.reviewRatingStatistics,
      },
    }))
    .reduce(
      (prev, { variants, masterVariant, mapFields }) => [
        ...prev,
        ...variants.concat({ ...masterVariant, _master: true }).map((variant) => ({ ...variant, ...mapFields })),
      ],
      [],
    );
}

function labelMatchesCriteria(label, criteria) {
  return criteria ? criteria.includes(label) : true;
}

export function getFacetGrouped(result, criteria) {
  if (!result?.data) {
    return [];
  }
  const { facets } = result.data;
  const { filters } = result.input;
  return facets
    .filter((item) => item.facet !== 'category' && labelMatchesCriteria(item.facet, criteria))
    .map(({ facet, value, total }) => ({
      id: facet,
      label: facet,
      count: total,
      options: value.terms.map(({ term, count, productCount }) => ({
        type: 'attribute',
        id: term,
        value: term,
        attrName: facet,
        selected: filters[facet]?.includes(term),
        count: productCount || count,
      })),
    }));
}

export function getFacetSortOptions(searchData) {
  const sortingOptions = commercetoolsConfig.faceting?.sortingOptions || [];
  const defaultSort = sortingOptions[0].id;
  const options = sortingOptions.map(({ id, name }) => ({
    type: 'sort',
    id,
    value: name,
  }));
  const selected = options.find((o) => o.id === searchData.input.sort)?.id || defaultSort;
  return { options, selected };
}
